import { render, staticRenderFns } from "./BigActionButton.vue?vue&type=template&id=10ce5df1&"
import script from "./BigActionButton.vue?vue&type=script&lang=js&"
export * from "./BigActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports